import styled from "styled-components";

export const FollowUsOnWrapper = styled.div`
  .follow_us_heading {
    margin-bottom: 50px;
    @media (max-width: 1199px) {
      margin-bottom: 30px;
    }
    @media (max-width: 899px) {
      margin-bottom: 20px;
    }
  }
  .maps_div {
    margin-top: 42px;
    width: 100%;
    border-radius: 25px;
    overflow: hidden;
    @media (max-width: 1199px) {
      margin-top: 30px;
      border-radius: 15px;
    }
    @media (max-width: 899px) {
      border-radius: 12px;
    }
    iframe {
      width: 100%;
      border: 0;
    }
  }
  .figureWrap {
    padding: 0 42px;
    line-height: 0;
    @media (max-width: 1199px) {
      padding: 0 20px;
    }
    @media (max-width: 599px) {
      padding: 0 15px;
    }
    figure {
      width: auto;
      height: 80px;
      line-height: 0;
      aspect-ratio: 2/1;
      @media (max-width: 599px) {
        height: 60px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
`;
